import Alert from "@mui/material/Alert"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import { axiosClient } from "../../common/axios"
import Column from "../../common/components/Column"
import CustomerAccessFields, {
  INITIAL_CUSTOMER_ACCESS_FORM,
  formatCustomerAccessError,
  toCustomerAccessPayload,
  useCustomerAccessCampaigns,
} from "../admin/components/CustomerAccessFields"

// Open support form that replaces the Airtable "Access Creation Form".
// The magic login link is never shown here: staff copy it from the admin.
export default function CustomerAccessForm() {
  const campaigns = useCustomerAccessCampaigns()
  const [form, setForm] = useState(INITIAL_CUSTOMER_ACCESS_FORM)
  // Honeypot: hidden from people, filled in by bots.
  const [website, setWebsite] = useState("")
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)
  const [createdEmail, setCreatedEmail] = useState(null)

  async function handleSubmit(event) {
    event.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      const payload = toCustomerAccessPayload(form)
      await axiosClient.post("/users/api/customer-access/", {
        ...payload,
        website,
      })
      setCreatedEmail(payload.email)
    } catch (err) {
      setError(formatCustomerAccessError(err, "Could not create access."))
    } finally {
      setSubmitting(false)
    }
  }

  function handleSubmitAnother() {
    setForm(INITIAL_CUSTOMER_ACCESS_FORM)
    setCreatedEmail(null)
    setError(null)
  }

  if (createdEmail) {
    return (
      <Column gap={2} sx={{ width: "100%" }}>
        <Typography variant="h5" component="h1" fontWeight={600}>
          Access created
        </Typography>
        <Alert severity="success">
          Customer access for {createdEmail} was created. The magic login link
          is in the OneBase admin under Users.
        </Alert>
        <Button variant="contained" onClick={handleSubmitAnother}>
          Submit another
        </Button>
      </Column>
    )
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
      <Column gap={2}>
        <Typography variant="h5" component="h1" fontWeight={600}>
          Access Creation Form
        </Typography>
        {error ? <Alert severity="error">{error}</Alert> : null}
        <CustomerAccessFields
          form={form}
          setForm={setForm}
          campaigns={campaigns}
        />
        <Box
          component="input"
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          sx={{ position: "absolute", left: "-10000px", opacity: 0 }}
        />
        <Button type="submit" variant="contained" disabled={submitting}>
          Submit
        </Button>
      </Column>
    </Box>
  )
}
